import { WordFeedback } from '@entities/lesson'
import { useTranslation } from '@shared/config/i18n'
import React from 'react'

import { Box, HStack, Typography, VStack } from '@podo-app/design-system-temp'

type Props = {
  feedback: WordFeedback
}

export const EnglishWordFeedback = ({ feedback }: Props) => {
  const t = useTranslation()

  return (
    <React.Fragment>
      <VStack className="gap-2">
        <HStack>
          <Box className="border rounded-[14px] px-3 py-[3px] bg-white border-gray-200">
            <Typography size="body1" className="font-medium">
              {t('lesson.feedbackLabels.word')}
            </Typography>
          </Box>
        </HStack>
        <VStack className="gap-0.5">
          <Typography size="h1" className="text-[22px] font-bold">
            {feedback.phrase.vocab}
          </Typography>
          <Typography size="body1" className="text-gray-500">
            {feedback.phrase.vocab_translation}
          </Typography>
        </VStack>
      </VStack>

      <Box className="border divide-dashed" />

      <VStack className="gap-2">
        <HStack>
          <Box className="border rounded-[14px] px-3 py-[3px] bg-white border-gray-200">
            <Typography size="body1" className="font-medium">
              {t('lesson.feedbackLabels.example')}
            </Typography>
          </Box>
        </HStack>
        <VStack className="gap-0.5">
          <Typography size="h3" className="font-medium">
            {feedback.phrase.example}
          </Typography>
          <Typography size="body1" className="text-gray-500">
            {feedback.phrase.example_translation}
          </Typography>
        </VStack>
      </VStack>
    </React.Fragment>
  )
}
